<template>
  <div class="">
    <el-dialog :before-close="close" :visible.sync="visible" :title="``" :width="type == 1 ? '600px' : '95%'" append-to-body center>
      <div class="dialog n-rela">
        <el-image @click="close" class="dialog-image" :src="require('@/assets/img/home-blacklist.png')" fit="cover">
          <el-image class="dialog-image" slot="error" :src="require('@/assets/img/xianyouhe-logo.png')" fit="cover"></el-image>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DialogBlackList",
  props: {
    // 显示
    visible: {
      type: Boolean,
      default: false
    },
    // 
    type: {
      type: [String, Number],
      default: 0,
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapState([""])
  },
  mounted () {

  },
  methods: {
    // 关闭弹框
    close () {
      this.$emit("close");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mobile.scss";

.dialog {
  &-image {
    width: 100%;
    cursor: pointer;
  }
}

::v-deep .el-dialog {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  background: transparent;

  .el-dialog__headerbtn {
    z-index: 1;
  }

  .el-icon-close {
    font-size: 22px;
    color: #FFF;
  }

  .el-dialog__body {
    padding: 0;
  }
}

// 进入动画
.dialog-fade-enter-active {
  animation: dialog-fade-in 1s;
}

// 离开动画
.dialog-fade-leave-active {
  animation: dialog-fade-out 1s;
}

@keyframes dialog-fade-in {
  0% {
    transform: scale(2);
    opacity: 0;
  }

  50% {
    transform: scale(2);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(2);
    opacity: 0;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
